import { render, staticRenderFns } from "./generalreport.vue?vue&type=template&id=35f21570&scoped=true&"
import script from "./generalreport.vue?vue&type=script&lang=js&"
export * from "./generalreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f21570",
  null
  
)

export default component.exports